import React, { useEffect } from 'react';

// Mise en page commune des pages légales (mentions légales, politique de
// confidentialité).

export const LegalSection = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-display text-2xl font-semibold text-[#21167D]">{title}</h2>
    <div className="space-y-3 text-[#4A4458] leading-relaxed">{children}</div>
  </section>
);

/** Repère visible d'une information encore inconnue. */
export const ToComplete = ({ children }) => (
  <mark className="bg-[#EAA93D]/25 text-[#21167D] font-medium px-1 rounded">[À COMPLÉTER : {children}]</mark>
);

const LegalLayout = ({ title, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F3EB]">
      <section className="pt-32 pb-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-display text-4xl md:text-5xl font-semibold text-[#21167D]">{title}</h1>
        </div>
      </section>
      <section className="pb-16 px-4">
        <div className="max-w-4xl mx-auto bg-[#FDFBF5] rounded-xl shadow-lg p-6 sm:p-10 space-y-10">
          {children}
        </div>
      </section>
    </div>
  );
};

export default LegalLayout;
